export const huntingPlanComparison = (a, b) => {
  if (b.quota && b.ring) return 1
  if (a.quota && a.ring) return -1
  if (b.quota && a.ring) return 1
  if (a.quota && b.ring) return -1
  return 1
}
